import React from 'react';
import '../../assets/css/loader.scss';

const Loader = ({ size = 'medium', color = 'primary', fullPage = false, text = '' }) => {
  const sizeClass = `loader-${size}`;
  const colorClass = `loader-${color}`;
  
  return (
    <div className={`loader-container ${fullPage ? 'loader-fullpage' : ''}`}>
      <div className={`loader ${sizeClass} ${colorClass}`} aria-label="Loading">
        <div className="loader-spinner"></div>
      </div>
      {text && <p className="loader-text">{text}</p>}
    </div>
  );
};

export default Loader;